import { UploadFile } from "antd";
import { Rule } from "antd/es/form";
import { useMemo } from "react";

export const useUploadFileRule = () => {
  const rule: Rule[] = useMemo(() => {
    return [
      () => ({
        validator(_: Rule, value: UploadFile[]) {
          if (value && value.length > 0) {
            const errors: any = value.filter((item: UploadFile) => item.error);

            const errorsSet: Set<string> = new Set(
              errors.map((item: UploadFile) => item.error)
            );

            if (errors && errors.length > 0) {
              return Promise.reject(errorsSet);
            } else {
              return Promise.resolve();
            }
          } else {
            return Promise.resolve();
          }
        },
      }),
    ];
  }, []);

  return { rule };
};
